import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export interface StorefrontRouterContext {
  queryClient: QueryClient;
}

function StorefrontRootRoute() {
  return <Outlet />;
}

export const rootRoute = createRootRouteWithContext<StorefrontRouterContext>()({
  component: StorefrontRootRoute,
});
